import { render } from "./pageCanvas.vue?vue&type=template&id=267be1e6&scoped=true"
import script from "./pageCanvas.vue?vue&type=script&lang=js"
export * from "./pageCanvas.vue?vue&type=script&lang=js"

import "./pageCanvas.vue?vue&type=style&index=0&id=267be1e6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267be1e6"]])

export default __exports__